/* Peak Labs - Homepage V2 (compiled offline with Babel 7, preset react).
   Defines window.HomeV2. The compiled bundles delegate Home -> window.HomeV2
   when present; the original Home stays in the bundle as fallback (HomeV1).
   Reads live globals at render time: CATALOGUE, PENS, getPen, ProductCardC,
   Icon, formatDhs, SHOW_COA, COA_DATA, PEAK_ASSETS, GoldMesh (lexical). */
(function () {
  var R = React;
  function A() {
    return window.PEAK_ASSETS || {};
  }
  function IconG(props) {
    var I = window.Icon;
    return I ? R.createElement(I, props) : null;
  }
  function fmt(n) {
    return window.formatDhs ? window.formatDhs(n) : "\u20c3\u00a0" + n;
  }
  function reducedMotion() {
    try {
      return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }
  function Mesh() {
    var M = typeof GoldMesh !== "undefined" ? GoldMesh : null;
    return M ? R.createElement(M, null) : null;
  }

  /* Floating pen: slow float + drift via CSS, pointer parallax + scroll
     parallax via JS. Everything off under prefers-reduced-motion. */
  const HeroPen = () => {
    const wrapRef = React.useRef(null);
    React.useEffect(() => {
      if (reducedMotion()) return;
      const el = wrapRef.current;
      if (!el) return;
      const fine = window.matchMedia && window.matchMedia("(pointer: fine)").matches;
      let tx = 0,
        ty = 0,
        cx = 0,
        cy = 0,
        sy = 0,
        raf = null,
        alive = true;
      const tick = () => {
        if (!alive) return;
        cx += (tx - cx) * 0.06;
        cy += (ty - cy) * 0.06;
        el.style.transform = "translate3d(" + cx.toFixed(2) + "px," + (cy - sy).toFixed(2) + "px,0) rotate(" + (cx * 0.05).toFixed(3) + "deg)";
        raf = requestAnimationFrame(tick);
      };
      const onMove = e => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        const dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        tx = Math.max(-1, Math.min(1, dx)) * 10;
        ty = Math.max(-1, Math.min(1, dy)) * 8;
      };
      const onLeave = () => {
        tx = 0;
        ty = 0;
      };
      const onScroll = () => {
        sy = Math.min(90, window.scrollY * 0.08);
      };
      if (fine) {
        document.addEventListener("mousemove", onMove, {
          passive: true
        });
        document.addEventListener("mouseleave", onLeave, {
          passive: true
        });
      }
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      raf = requestAnimationFrame(tick);
      return () => {
        alive = false;
        if (raf) cancelAnimationFrame(raf);
        if (fine) {
          document.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseleave", onLeave);
        }
        window.removeEventListener("scroll", onScroll);
      };
    }, []);
    const src = A().penHero || A().penRetaNobg;
    return /*#__PURE__*/React.createElement("div", {
      className: "hv2-pen",
      ref: wrapRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-pen__float"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-pen__drift"
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: "Peak Labs GLP3 (RT) research pen",
      className: "hv2-pen__img",
      width: "760",
      height: "805",
      fetchpriority: "high",
      onError: e => {
        if (A().penRetaNobg && e.currentTarget.src !== A().penRetaNobg) e.currentTarget.src = A().penRetaNobg;
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "hv2-pen__shadow",
      "aria-hidden": "true"
    }));
  };
  const Hero = ({
    onNavigate
  }) => /*#__PURE__*/React.createElement("section", {
    className: "hv2-hero"
  }, /*#__PURE__*/React.createElement(Mesh, null), /*#__PURE__*/React.createElement("div", {
    className: "hv2-hero__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hv2-hero__copy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hv2-eyebrow"
  }, "Research-grade peptides \xB7 UAE"), /*#__PURE__*/React.createElement("h1", {
    className: "hv2-h1"
  }, "Precision Peptides,", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("em", null, "laboratory-grade.")), /*#__PURE__*/React.createElement("p", {
    className: "hv2-lede"
  }, "Pre-filled precision pens and lyophilised vials, independently lab tested and delivered across the UAE."), /*#__PURE__*/React.createElement("div", {
    className: "hv2-ctas"
  }, /*#__PURE__*/React.createElement("button", {
    className: "lux-btn lux-btn--gold",
    onClick: () => onNavigate && onNavigate("/shop")
  }, "Shop Peptides ", /*#__PURE__*/React.createElement(IconG, {
    name: "chevron-right",
    size: 15
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "hv2-badges"
  }, /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "flask",
    size: 17
  }), window.SHOW_COA ? /*#__PURE__*/React.createElement("a", {
    href: "#/coa",
    onClick: e => {
      e.preventDefault();
      onNavigate && onNavigate("/coa");
    }
  }, "Independent lab tested \xB7 HPLC + ICP-MS") : /*#__PURE__*/React.createElement("span", null, "Independent lab tested \xB7 HPLC + ICP-MS")), /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "truck",
    size: 17
  }), /*#__PURE__*/React.createElement("span", null, "1-2 day UAE delivery")), /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "check",
    size: 17
  }), /*#__PURE__*/React.createElement("span", null, "\u20c3\u00a060 flat UAE delivery")))), /*#__PURE__*/React.createElement(HeroPen, null)));
  const FormatBand = ({
    onNavigate
  }) => {
    const vialCount = (window.CATALOGUE || []).length;
    const penCount = (window.PENS || []).length;
    const go = to => e => {
      e.preventDefault();
      onNavigate && onNavigate(to);
    };
    return /*#__PURE__*/React.createElement("section", {
      className: "hv2-format"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-eyebrow"
    }, "Choose your format"), /*#__PURE__*/React.createElement("h2", {
      className: "hv2-h2"
    }, "Pens, vials or sprays.")), /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__grid"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#/pens",
      className: "hv2-format__card",
      onClick: go("/pens")
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__visual"
    }, /*#__PURE__*/React.createElement("img", {
      src: A().penHero || A().penRetaNobg,
      alt: "Peak Labs pre-filled research pen",
      loading: "lazy",
      decoding: "async",
      width: "440",
      height: "466",
      onError: e => {
        if (A().penRetaNobg && e.currentTarget.src !== A().penRetaNobg) e.currentTarget.src = A().penRetaNobg;
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__copy"
    }, /*#__PURE__*/React.createElement("h3", null, "Pens"), /*#__PURE__*/React.createElement("p", {
      className: "hv2-format__count"
    }, penCount, " pens \xB7 pre-filled"), /*#__PURE__*/React.createElement("p", null, "Reconstituted and pre-filled. No mixing, no draw-up, dial by clicks."), /*#__PURE__*/React.createElement("span", {
      className: "hv2-format__link"
    }, "Browse pens ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 14
    })))), /*#__PURE__*/React.createElement("a", {
      href: "#/peptides",
      className: "hv2-format__card",
      onClick: go("/peptides")
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__visual"
    }, /*#__PURE__*/React.createElement("img", {
      src: A().vialCut || A().retatrutide,
      alt: "Peak Labs research peptide vial",
      loading: "lazy",
      decoding: "async",
      width: "440",
      height: "683",
      onError: e => {
        if (A().retatrutide && e.currentTarget.src !== A().retatrutide) e.currentTarget.src = A().retatrutide;
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__copy"
    }, /*#__PURE__*/React.createElement("h3", null, "Vials"), /*#__PURE__*/React.createElement("p", {
      className: "hv2-format__count"
    }, vialCount, " products \xB7 lyophilised"), /*#__PURE__*/React.createElement("p", null, "Reconstitute and draw exactly what your protocol calls for."), /*#__PURE__*/React.createElement("span", {
      className: "hv2-format__link"
    }, "Browse vials ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 14
    })))), /*#__PURE__*/React.createElement("a", {
      href: "#/sprays",
      className: "hv2-format__card",
      onClick: go("/sprays")
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__visual"
    }, window.SPRAY_HERO ? /*#__PURE__*/React.createElement("img", {
      src: window.SPRAY_HERO,
      alt: "Peak Labs nasal spray",
      loading: "lazy",
      decoding: "async",
      width: "440",
      height: "466"
    }) : /*#__PURE__*/React.createElement(IconG, {
      name: "flask",
      size: 46
    })), /*#__PURE__*/React.createElement("div", {
      className: "hv2-format__copy"
    }, /*#__PURE__*/React.createElement("h3", null, "Sprays"), /*#__PURE__*/React.createElement("p", {
      className: "hv2-format__count"
    }, "3 peptides \xB7 nasal"), /*#__PURE__*/React.createElement("p", null, "Metered nasal sprays for Selank, Semax and PT-141. No needles."), /*#__PURE__*/React.createElement("span", {
      className: "hv2-format__link"
    }, "Browse sprays ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 14
    }))))));
  };
  const Bestsellers = ({
    onOpenProduct,
    onNavigate,
    onAddToCart
  }) => {
    const TOP = ["retatrutide-pen", "ghk-cu-pen", "tesamorelin-pen", "bpc-157-tb-pen"];
    const getPen = window.getPen,
      PenCard = window.PenCard;
    if (!getPen || !PenCard) return null;
    const pens = TOP.map(id => getPen(id)).filter(p => p && TOP.indexOf(p.id) !== -1);
    if (!pens.length) return null;
    return /*#__PURE__*/React.createElement("section", {
      className: "section hv2-best"
    }, /*#__PURE__*/React.createElement("div", {
      className: "section__head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: "hv2-best__h2"
    }, "Best Sellers")), /*#__PURE__*/React.createElement("button", {
      className: "btn btn--ghost hv2-best__all",
      onClick: () => onNavigate("/pens")
    }, "Shop all pens ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 15
    }))), /*#__PURE__*/React.createElement("div", {
      className: "product-grid"
    }, pens.map(p => /*#__PURE__*/React.createElement(PenCard, {
      key: p.id,
      pen: p,
      onOpen: id => onNavigate("/pen/" + id),
      onAdd: onAddToCart
    }))));
  };
  const Spotlight = ({
    onNavigate,
    onAddToCart
  }) => {
    const pen = window.getPen ? window.getPen("retatrutide-pen") : null;
    const [sel, setSel] = React.useState(0);
    if (!pen || !pen.variants || pen.id !== "retatrutide-pen") return null;
    const v = pen.variants[sel] || pen.variants[0];
    const img = v.image || A().penHero || A().penRetaNobg;
    const add = () => {
      if (!onAddToCart) return;
      const cp = {
        ...pen,
        id: pen.id + "::" + v.dose,
        dose: v.dose,
        price: v.price,
        variantId: v.variantId,
        image: v.image || pen.image
      };
      onAddToCart(cp, 1, false);
    };
    return /*#__PURE__*/React.createElement("section", {
      className: "hv2-spot"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-spot__inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-spot__visual"
    }, /*#__PURE__*/React.createElement("img", {
      src: img,
      alt: "GLP3 (RT) pen " + v.dose,
      loading: "lazy",
      decoding: "async",
      width: "520",
      height: "551"
    })), /*#__PURE__*/React.createElement("div", {
      className: "hv2-spot__copy"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-eyebrow"
    }, "Featured"), /*#__PURE__*/React.createElement("h2", {
      className: "hv2-h2"
    }, "The GLP3 (RT) Pen."), /*#__PURE__*/React.createElement("p", {
      className: "hv2-body"
    }, "GLP3 (RT), reconstituted in bacteriostatic water and pre-filled into a multi-dose research pen. Dial your amount one click at a time, no mixing, no draw-up."), /*#__PURE__*/React.createElement("div", {
      className: "hv2-spot__doses",
      role: "group",
      "aria-label": "Choose a size"
    }, pen.variants.map((pv, i) => /*#__PURE__*/React.createElement("button", {
      key: pv.dose,
      className: "hv2-dosebtn" + (i === sel ? " is-active" : ""),
      "aria-pressed": i === sel,
      onClick: () => setSel(i)
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-dosebtn__mg"
    }, pv.dose), /*#__PURE__*/React.createElement("span", {
      className: "hv2-dosebtn__price"
    }, fmt(pv.price))))), /*#__PURE__*/React.createElement("div", {
      className: "hv2-spot__actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "lux-btn lux-btn--gold",
      onClick: add
    }, "Add to cart \xB7 ", fmt(v.price)), /*#__PURE__*/React.createElement("a", {
      href: "#/pen/retatrutide-pen",
      className: "hv2-spot__pdp",
      onClick: e => {
        e.preventDefault();
        onNavigate && onNavigate("/pen/retatrutide-pen");
      }
    }, "1 click = 0.01 mL \xB7 view pen details ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 14
    }))))));
  };
  const LabSection = ({
    onNavigate
  }) => {
    const showCoa = !!window.SHOW_COA;
    const measured = showCoa ? (window.COA_DATA || []).filter(c => c.purity && c.coaPurityUrl) : [];
    const PILLARS = [{
      i: "shield",
      t: "Independent labs",
      d: "Batches are analysed by a third-party laboratory, never self-reported."
    }, {
      i: "flask",
      t: "HPLC + ICP-MS",
      d: "HPLC quantifies purity and identity; ICP-MS screens for heavy metals."
    }, {
      i: "truck",
      t: "Cold chain",
      d: "Temperature-controlled handling and delivery, 2 to 8°C door to door."
    }, {
      i: "file",
      t: "Research use only",
      d: "Supplied for laboratory research, with documentation to match."
    }];
    return /*#__PURE__*/React.createElement("section", {
      className: "hv2-lab"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-lab__head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-eyebrow hv2-eyebrow--onDark"
    }, "The proof"), /*#__PURE__*/React.createElement("h2", {
      className: "hv2-h2"
    }, "Tested. Verified. Documented."), /*#__PURE__*/React.createElement("p", {
      className: "hv2-body"
    }, "Every compound is screened by an independent third-party laboratory before it reaches a bench.")), /*#__PURE__*/React.createElement("div", {
      className: "hv2-lab__grid"
    }, PILLARS.map(p => /*#__PURE__*/React.createElement("div", {
      key: p.t,
      className: "hv2-lab__card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-lab__icon"
    }, /*#__PURE__*/React.createElement(IconG, {
      name: p.i,
      size: 24
    })), /*#__PURE__*/React.createElement("h3", null, p.t), /*#__PURE__*/React.createElement("p", null, p.d)))), /*#__PURE__*/React.createElement("div", {
      className: "hv2-lab__coa"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-lab__ctas"
    }, /*#__PURE__*/React.createElement("button", {
      className: "lux-btn lux-btn--gold",
      onClick: () => onNavigate && onNavigate("/shop")
    }, "Shop Peptides ", /*#__PURE__*/React.createElement(IconG, {
      name: "chevron-right",
      size: 15
    })), showCoa && /*#__PURE__*/React.createElement("button", {
      className: "lux-btn lux-btn--ghost",
      onClick: () => onNavigate && onNavigate("/coa")
    }, "Browse the COA Library"))));
  };
  const ProcessBand = () => {
    const STEPS = [{
      t: "Sourced",
      d: "Procured exclusively from screened laboratory suppliers with documented quality systems."
    }, {
      t: "Verified",
      d: "Every batch independently tested by HPLC to confirm purity meets laboratory-grade standards."
    }, {
      t: "Delivered",
      d: "Discreetly packaged and dispatched across the UAE, delivered within 1-2 business days."
    }];
    return /*#__PURE__*/React.createElement("section", {
      className: "hv2-process"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hv2-process__head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-eyebrow"
    }, "The standard"), /*#__PURE__*/React.createElement("h2", {
      className: "hv2-h2"
    }, "Lab-grade, every step.")), /*#__PURE__*/React.createElement("ol", {
      className: "hv2-process__grid"
    }, STEPS.map((s, i) => /*#__PURE__*/React.createElement("li", {
      key: s.t,
      className: "hv2-process__step"
    }, /*#__PURE__*/React.createElement("span", {
      className: "hv2-process__no"
    }, "0" + (i + 1)), /*#__PURE__*/React.createElement("h3", null, s.t), /*#__PURE__*/React.createElement("p", null, s.d)))));
  };
  const CtaBand = ({
    onNavigate
  }) => /*#__PURE__*/React.createElement("section", {
    className: "hv2-cta"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "hv2-h2 hv2-h2--onDark"
  }, "Ready when your research is."), /*#__PURE__*/React.createElement("p", {
    className: "hv2-cta__sub"
  }, "Delivery within 1-2 days across the UAE. Email us for anything else."), /*#__PURE__*/React.createElement("div", {
    className: "hv2-ctas hv2-ctas--center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "lux-btn hv2-btn--ivory",
    onClick: () => onNavigate && onNavigate("/shop")
  }, "Shop Peptides ", /*#__PURE__*/React.createElement(IconG, {
    name: "chevron-right",
    size: 15
  })), /*#__PURE__*/React.createElement("a", {
    className: "lux-btn hv2-btn--outline-ivory",
    href: "https://wa.me/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Message us on WhatsApp")), /*#__PURE__*/React.createElement("ul", {
    className: "hv2-badges hv2-badges--onDark"
  }, /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "flask",
    size: 16
  }), /*#__PURE__*/React.createElement("span", null, "Independent lab tested")), /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "truck",
    size: 16
  }), /*#__PURE__*/React.createElement("span", null, "Fast UAE delivery")), /*#__PURE__*/React.createElement("li", {
    className: "hv2-badge"
  }, /*#__PURE__*/React.createElement(IconG, {
    name: "check",
    size: 16
  }), /*#__PURE__*/React.createElement("span", null, "UAE delivery"))));
  const CATS_ORDER = ["metabolic", "gh-axis", "regenerative", "skin", "mitochondrial", "neuro", "vitality"];
  const CategoryBand = ({ onNavigate }) => {
    const all = window.CATEGORIES || [];
    const cats = CATS_ORDER.map(id => all.find(c => c.id === id)).filter(Boolean);
    if (!cats.length) return null;
    return /*#__PURE__*/R.createElement("section", { className: "hv2-cats" }, /*#__PURE__*/R.createElement("div", { className: "hv2-cats__head" }, /*#__PURE__*/R.createElement("span", { className: "hv2-eyebrow" }, "Find it faster"), /*#__PURE__*/R.createElement("h2", { className: "hv2-h2" }, "Shop by category.")), /*#__PURE__*/R.createElement("div", { className: "hv2-cats__grid" }, cats.map(c => /*#__PURE__*/R.createElement("button", { key: c.id, className: "hv2-catbtn", onClick: () => { window.__penCat = c.id; onNavigate && onNavigate("/pens"); } }, /*#__PURE__*/R.createElement("span", { className: "hv2-catbtn__label" }, c.label), /*#__PURE__*/R.createElement(IconG, { name: "chevron-right", size: 15 })))));
  };
  const HomeV2 = ({
    onOpenProduct,
    onNavigate,
    onAddToCart
  }) => /*#__PURE__*/React.createElement("main", {
    id: "main",
    tabIndex: -1,
    className: "hv2"
  }, /*#__PURE__*/React.createElement(Hero, {
    onNavigate: onNavigate
  }), /*#__PURE__*/React.createElement(FormatBand, {
    onNavigate: onNavigate
  }), /*#__PURE__*/React.createElement(WhyBand, null), /*#__PURE__*/React.createElement(Bestsellers, {
    onOpenProduct: onOpenProduct,
    onNavigate: onNavigate,
    onAddToCart: onAddToCart
  }));
  const ConsultBand = () => /*#__PURE__*/React.createElement("section", {
    className: "hv2-consult"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hv2-consult__inner"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hv2-eyebrow"
  }, "New to peptides?"), /*#__PURE__*/React.createElement("h2", {
    className: "hv2-h2"
  }, "Book a free call with our team"), /*#__PURE__*/React.createElement("p", {
    className: "hv2-consult__sub"
  }, "Talk it through one-on-one: what each peptide does, how to choose, dosing, and any questions you have. Email us and we'll set up a time that suits you."), /*#__PURE__*/React.createElement("a", {
    className: "hv2-consult__btn",
    href: "https://wa.me/?text=Hi%20Peak%20Labs%2C%20I%27d%20like%20to%20book%20a%20call%20to%20learn%20about%20peptides.",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "hv2-consult__wa",
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 0 0-8.6 15l-1.3 4.8 4.9-1.3A10 10 0 1 0 12 2zm5.8 14.2c-.2.7-1.4 1.3-2 1.4-.5.1-1.2.1-1.9-.1-.4-.1-1-.3-1.7-.6-3-1.3-5-4.4-5.1-4.6-.2-.2-1.3-1.7-1.3-3.2s.8-2.3 1.1-2.6c.3-.3.6-.4.8-.4h.6c.2 0 .5 0 .7.5l.9 2.1c.1.2.1.4 0 .6l-.4.6c-.2.2-.4.5-.2.8.2.4.9 1.5 2 2.4 1.3 1.1 2.3 1.5 2.7 1.6.3.1.5.1.7-.1l.8-1c.2-.3.5-.2.8-.1l2 1c.3.1.5.2.6.3.1.2.1.8-.1 1.5z"
  })), "Book a call on WhatsApp")));
  window.ConsultBand = ConsultBand;

  function whyCard(icon, t, d) {
    return /*#__PURE__*/React.createElement("div", { className: "hv2-whycard" },
      /*#__PURE__*/React.createElement("div", { className: "hv2-whycard__icon" }, /*#__PURE__*/React.createElement(IconG, { name: icon, size: 24 })),
      /*#__PURE__*/React.createElement("h3", null, t),
      /*#__PURE__*/React.createElement("p", null, d));
  }
  const WhyBand = () => /*#__PURE__*/React.createElement("section", { className: "hv2-why" },
    /*#__PURE__*/React.createElement("div", { className: "hv2-why__head" },
      /*#__PURE__*/React.createElement("span", { className: "hv2-eyebrow" }, "Why Peak Labs"),
      /*#__PURE__*/React.createElement("h2", { className: "hv2-h2" }, "Research-grade, delivered within 1-2 days.")),
    /*#__PURE__*/React.createElement("div", { className: "hv2-why__grid" },
      whyCard("shield", "Independent lab-tested purity", "Every batch is verified by Janoshik: HPLC for purity and identity, ICP-MS for heavy metals. Real certificates, never self-reported."),
      whyCard("truck", "1-2 day UAE delivery", "Fast, discreet delivery across the UAE within 1-2 days. Flat \u20c3\u00a060."),
      whyCard("check", "Research-grade compounds", "High-purity reference peptides and lab compounds, as pre-filled pens or lyophilised vials, ready for the bench.")));
  window.WhyBand = WhyBand;

  window.HomeV2 = HomeV2;
})();